import { FieldKey, TestResolver } from "../../models";
import { buildFieldConfig } from "../booking-calendar.column-passengers.helpers";

const MAX_ROWS_EXCLUDE_FIRST_ROW = 4;

export const bookingPassengerCellInfoMaxRows: TestResolver = ({
  context,
  validationAdditional,
  value,
  errorMessage,
}) => {
  const passengerCellFieldsInfo = context.parent?.passengerCellData ?? [];

  if (!value || !passengerCellFieldsInfo?.length) {
    return true;
  }

  const { fieldConfig, orderedFieldKeys } = buildFieldConfig(
    passengerCellFieldsInfo,
  );

  const passengerCellFieldsInfoRowsComputed = orderedFieldKeys.filter(
    (field: string) =>
      fieldConfig[field as FieldKey]?.show &&
      !fieldConfig[field as FieldKey]?.excludeFromMapList,
  );

  if (
    passengerCellFieldsInfoRowsComputed.length <= MAX_ROWS_EXCLUDE_FIRST_ROW
  ) {
    return true;
  }

  return context.createError({ message: errorMessage, path: context.path });
};
